<template>
  <div class="Serve-container">
    <div class="Serve-title">核心能力</div>
    <div class="Serve-list">
       
        <div class="list-item" v-for="(it,index) in list" :key="index">
            <img class="logo" :src="it.img" alt="">
            <p class="item-title">{{it.title}}</p>
            <p class="item-content">{{it.content}}</p>
        </div>

    </div>
  </div>
</template>

<script>
import img1 from "@/assets1/首页-未登录_slices/位图(2).png" 
import img2 from "@/assets1/首页-未登录_slices/位图(3).png" 
import img3 from "@/assets1/首页-未登录_slices/位图(4).png" 
export default {

data(){
    return{
        list:[{
            title:'多维度海量数据',
            content:'包含全球典型的开放数据集案例，覆盖12大垂直行业，文本、图片、音频、视频、3D等多种数据类型',
            img:img1
        },
        {
            title:'区块链技术',
            content:'使用区块链技术实现可信传输和数据集存证，保护数据所有者的权益.',
            img:img2
        },
        {
            title:'支持定制化',
            content:'提供定制化数据集方案',
            img:img3
        }
        ]
    }
}
}
</script>

<style scoped>
.Serve-title{
    /* margin-top: 40px;
      
    font-size:33px ;
    font-weight: 500; */
color: #fff;
font-family: Medium;
font-weight: 500;
font-size: 36px;

font-style: normal;
margin-bottom: 60px;
}
.logo{
    width: 80px;
    height: 80px;
    object-fit: cover;
    /* margin: 0 auto; */
}
.Serve-container{
padding-top: 100px;
min-width:1920px ;
padding-bottom: 100px;
background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E8%B6%85%E5%B8%82%E4%BB%8B%E7%BB%8D%E9%A1%B5/%E4%BD%8D%E5%9B%BE%281%29.png');
 background-size: 100%;
text-align: center;
}
.Serve-list{
    display: flex;
    justify-content: center;
}
.list-item{
    width: 360px;

    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    text-align: center;
    padding: 0 20px;
}
.item-title{
    /* margin-top: 20px;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 10px; */
    margin-top: 40px;
     margin-bottom: 15px;
font-family: Medium;
font-weight: 500;
font-size: 18px;
color: #fff;
line-height: 25px;

font-style: normal;
}
.item-content{
    font-family: Regular;

    font-size: 15px;
  color: rgba(255, 255, 255, .6);
     letter-spacing:1px;
}
</style>